import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { AccessTime, Home } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function ComingSoon() {
  const navigate = useNavigate();
  const targetDate = new Date("2026-06-17T00:00:00").getTime(); // Example launch date

  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, mins: 0, secs: 0 });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          mins: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          secs: Math.floor((distance % (1000 * 60)) / 1000),
        });
      } else {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, mins: 0, secs: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #FEF0E9 0%, #FFF 100%)",
        flexDirection: "column",
        textAlign: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 6,
          borderRadius: 4,
          maxWidth: 500,
          bgcolor: "#fff",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: "bold", color: "#F36421", mb: 2 }}>
          🚀 Coming Soon!
        </Typography>
        <Typography variant="h6" sx={{ color: "#555", mb: 4 }}>
          We're working hard to bring this feature to you. Stay tuned!
        </Typography>

        {/* Countdown */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4 }}>
          <TimeBox label="Days" value={timeLeft.days} />
          <TimeBox label="Hours" value={timeLeft.hours} />
          <TimeBox label="Mins" value={timeLeft.mins} />
          <TimeBox label="Secs" value={timeLeft.secs} />
        </Box>

        <Button
          variant="contained"
          startIcon={<Home />}
          onClick={() => navigate("/learner-dash")}
          sx={{
            textTransform: "none",
            bgcolor: "#F36421",
            "&:hover": { bgcolor: "#d7551c" },
            borderRadius: 2,
            px: 3,
          }}
        >
          Back to Dashboard
        </Button>
      </Paper>

      <Box sx={{ mt: 5, display: "flex", alignItems: "center", color: "#777" }}>
        <AccessTime sx={{ mr: 1 }} />
        <Typography variant="body2">
          Estimated Launch: june 15, 2026
        </Typography>
      </Box>
    </Box>
  );
}

// Helper component for time display
function TimeBox({ label, value }) {
  return (
    <Box
      sx={{
        textAlign: "center",
        bgcolor: "#FEF0E9",
        px: 3,
        py: 2,
        borderRadius: 2,
        minWidth: 70,
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: "bold", color: "#F36421" }}>
        {value}
      </Typography>
      <Typography variant="caption" sx={{ color: "#333" }}>
        {label}
      </Typography>
    </Box>
  );
}
